import { setError } from 'js/actions';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { useSelector } from 'react-redux';

export default function useRequests() {
  const dispatch = useAppDispatch();
  const request = useSelector((state: any) => state.request);

  function isLoading(...keys) {
    return keys.some((key) => !!request[key]);
  }

  function showError(message) {
    dispatch(setError({ message }));
  }

  return {
    isLoading,
    showError,
  };
}
